export abstract class ResetPasswordBase {
  constructor(
    public email?: string,
    public token?: string,
    public password?: string,
    public passwordConfirmation?: string
  ) {}

  public toRequest() {
    return {
      email: this.email,
      token: this.token,
      password: this.password,
      passwordConfirmation: this.passwordConfirmation,
    };
  }
}
